interface ResultsItem {
  title: string;
  url: string;
}

export default function HeaderSAYT() {
  const wrapper: HTMLDivElement | null = document.querySelector(".js-header-sayt");
  const openBtn: HTMLButtonElement | null | undefined = wrapper?.querySelector(".js-sayt-open-btn");
  const closeBtn: HTMLButtonElement | null | undefined = wrapper?.querySelector(".js-sayt-close-btn");
  const submitBtn: HTMLButtonElement | null | undefined = wrapper?.querySelector(".js-sayt-submit-btn");
  const searchMenu: HTMLDivElement | null | undefined = wrapper?.querySelector(".js-sayt-menu");
  const searchInput: HTMLInputElement | null | undefined = wrapper?.querySelector(".js-sayt-input");
  const resultsListWrapper: HTMLDivElement | null | undefined = wrapper?.querySelector(".js-sayt-results-wrapper");
  const resultsList: HTMLDivElement | null | undefined = wrapper?.querySelector(".js-sayt-results");
  let results: ResultsItem[] = [];

  if (wrapper && openBtn && closeBtn && submitBtn && searchMenu && searchInput && resultsListWrapper && resultsList) {
    const handleResize = () => {
      handleCloseSearchMenu();
    };

    function debounce<T extends (...args: any[]) => void>(fn: T, delay: number): (...args: Parameters<T>) => void {
      let timeoutId: ReturnType<typeof setTimeout>;

      return function (...args: Parameters<T>): void {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          fn(...args);
        }, delay);
      };
    }

    const handleCreateItem = (url: string, title: string) => {
      return `
            <li class="sayt-result-item">
                <a href="${url}" class="sayt-link">
                    <span>${title}</span>
                    <span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M1.66669 8H14H13.6667" stroke="#41424C" stroke-miterlimit="10" stroke-linecap="square"></path>
                            <path d="M9.33331 12.6667L14 8.00001L9.33331 3.33334" stroke="#41424C" stroke-miterlimit="10" stroke-linecap="square"></path>
                        </svg>
                    </span>
                </a>
            </li>
        `;
    };

    const handleResultItems = () => {
      if (results.length > 0) {
        resultsListWrapper.setAttribute("data-results", "true");
        resultsList.hidden = false;

        results.forEach((item: ResultsItem) => {
          const newItem = handleCreateItem(item.url, item.title);

          resultsList.insertAdjacentHTML("beforeend", newItem);
        });
      } else {
        handleRemoveResults();
      }
    };

    const handleRemoveResults = () => {
      resultsListWrapper.setAttribute("data-results", "false");
      resultsList.hidden = true;
      const resultItems = resultsList.querySelectorAll("li");

      resultItems.forEach((item) => item.remove());
    };

    const handleToggleSearchMenu = () => {
      if (searchMenu.getAttribute("data-open") === "true") {
        handleCloseSearchMenu();
      } else {
        searchMenu.setAttribute("data-open", "true");
        closeBtn.tabIndex = 0;
        submitBtn.tabIndex = 0;
        searchInput.tabIndex = 0;
      }
    };

    const handleCloseSearchMenu = () => {
      searchMenu.setAttribute("data-open", "false");
      searchInput.value = "";
      closeBtn.tabIndex = -1;
      submitBtn.tabIndex = -1;
      searchInput.tabIndex = -1;
      handleRemoveResults();
    };

    const handleFetchResults = async (query: string) => {
      try {
        const url = `/api/search?q=${query}&c=7`;

        const response = await fetch(url);

        if (!response.ok) {
          throw new Error(`Request failed with status ${response.status}`);
        }

        const data = await response.json();

        results = [];
        handleRemoveResults();

        if (data.searchResults?.items && data.searchResults.items.length > 0) {
          results = data.searchResults.items;
        }
        handleResultItems();
      } catch (error) {
        console.error("Error during GET request:", error);
      }
    };

    const handleSubmitSearch = () => {
      const searchPageUrl: string = searchMenu.getAttribute("data-action") || "";
      const query: string = searchInput.value;
      if (searchPageUrl && query) {
        window.location.href = `${searchPageUrl}?q=${query}`;
      }
    };

    const handleKeyUpEvent = (e: KeyboardEvent) => {
      if (e.code === "Enter") {
        handleSubmitSearch();
      } else {
        if (searchInput.value.length > 2) {
          handleFetchResults(searchInput.value);
        } else {
          results = [];
          handleRemoveResults();
        }
      }
    };

    searchInput.addEventListener("keyup", debounce(handleKeyUpEvent, 300));
    openBtn.addEventListener("click", handleToggleSearchMenu);
    closeBtn.addEventListener("click", handleCloseSearchMenu);
    submitBtn.addEventListener("click", handleSubmitSearch);
    window.addEventListener("resize", handleResize);
  }
}
